import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceMaskIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M13.7453 12C12.4803 13.8135 10.3788 15 8 15C5.62125 15 3.51965 13.8135 2.2547 12H4V12.0961C4 12.2958 4.14722 12.4649 4.34497 12.4924L5.93646 12.7134C7.30557 12.9036 8.6944 12.9036 10.0635 12.7134L11.655 12.4924C11.8528 12.4649 12 12.2958 12 12.0961V12H13.7453Z"
		/>
		<path
			fill="currentColor"
			d="M4 11H1.67365C1.2417 10.0908 1 9.07361 1 8C1 7.96527 1.00024 7.9306 1.00076 7.896L4 8.98657V11Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1C4.52048 1 1.63391 3.5387 1.09155 6.86487L4.37778 8.05988C4.38528 8.05951 4.39285 8.05927 4.40048 8.05933L4.40976 8.05945C4.42471 8.05988 4.43982 8.0611 4.45502 8.06317L5.93646 8.26898C7.3056 8.45911 8.69443 8.45911 10.0635 8.26898L11.545 8.06317C11.5711 8.05957 11.597 8.05853 11.6222 8.05988L14.9084 6.86487C14.3661 3.5387 11.4795 1 8 1ZM10 5C9.44772 5 9 5.44769 9 6V6.5C9 6.77612 9.22385 7 9.5 7H10.5C10.7762 7 11 6.77612 11 6.5V6C11 5.44769 10.5523 5 10 5ZM5 6C5 5.44769 5.44772 5 6 5C6.55228 5 7 5.44769 7 6V6.5C7 6.77612 6.77615 7 6.5 7H5.5C5.22385 7 5 6.77612 5 6.5V6Z"
		/>
		<path
			fill="currentColor"
			d="M14.3264 11C14.7583 10.0908 15 9.07361 15 8C15 7.96527 14.9998 7.9306 14.9992 7.896L12 8.98657V11H14.3264Z"
		/>
		<path
			fill="currentColor"
			d="M5.44418 9.04938C5.20721 9.02301 5 9.2085 5 9.4469V11.3087C5 11.5125 5.15326 11.6837 5.35583 11.7062L6.34354 11.8159C7.44446 11.9383 8.55554 11.9383 9.65646 11.8159L10.6442 11.7062C10.8467 11.6837 11 11.5125 11 11.3087V9.4469C11 9.2085 10.7928 9.02301 10.5558 9.04938L9.65646 9.14929C8.55554 9.27161 7.44446 9.27161 6.34354 9.14929L5.44418 9.04938Z"
		/>
	</svg>
))
